import { Grid } from '@mui/material';
import { LuMessagesSquare } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { EmailLog } from 'wisestep-api';
import { WsColors, WsIconText, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import MapConversationIcon from '../../../../features/conversationWidget/components/MapConversationIcon';
import WsAvatar from '../../../../features/teams/components/WsAvatar';
import PersonAvatar from '../../../../images/Avatar/Person.svg';
import { getRedirectionUrl } from '../../util/JobCampaignEmailHelper';

export const EmailHeaderBanner = ({
  userImageUrl = PersonAvatar,
  emailLog,
}: {
  userImageUrl?: string;
  emailLog: EmailLog;
}) => {
  const navigate = useNavigate();
  const handleNavigation = (url: string) => navigate(url);
  return (
    <Grid
      p={2}
      display="flex"
      direction="column"
      rowGap={1.5}
      sx={{
        minHeight: 100,
        backgroundColor: WsColors.TertiaryShades50,
        borderRadius: 2,
      }}
    >
      <Grid item container display="flex" alignItems="center" columnGap={1}>
        <Grid item>
          <WsAvatar src={userImageUrl} />
        </Grid>
        <Grid item>
          <WsTypography
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY600}
            cursor="pointer"
            onClick={() => handleNavigation(getRedirectionUrl(emailLog.candidateId, 'profile'))}
          >
            {emailLog?.candidateName ?? `Candidate Name`}
          </WsTypography>
          <WsTypography variant={WsTypoVariants.BODY2} opacity={true}>
            {emailLog?.jobCode && emailLog?.jobTitle
              ? `${emailLog?.jobTitle} (${emailLog?.jobCode})`
              : 'Job info'}
          </WsTypography>
        </Grid>
      </Grid>
      <Grid item container alignItems="center" columnGap={2} ml={1}>
        <WsIconText
          icon={<LuMessagesSquare color={WsColors.TertiaryShades600} fontSize={18} />}
          text={'View Communication Logs'}
          textSize={WsTypoVariants.BODY1}
          textColor={WsTypoColors.PRIMARY600}
          textCursor="pointer"
          onClick={() =>
            handleNavigation(getRedirectionUrl(emailLog.candidateId, 'communication-logs'))
          }
        />
        <WsIconText
          icon={<MapConversationIcon color={WsColors.TertiaryShades600} height={18} width={18} />}
          text={'View Conversations'}
          textSize={WsTypoVariants.BODY1}
          textColor={WsTypoColors.PRIMARY600}
          textCursor="pointer"
          onClick={() => handleNavigation(getRedirectionUrl(emailLog.candidateId, 'mappings'))}
        />
      </Grid>
    </Grid>
  );
};
